import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { FormGroup, FormControl } from '@angular/forms'
import { Subscription } from 'rxjs'
import { SignerOptionItem } from '../signer-input-base.component'
import { SignerCustomInputComponent } from '../signer-input/signer-custom-input.component'
import { Destroyable, untilDestroy } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-signer-item-form',
  templateUrl: './signer-item-form.component.html',
  styleUrls: ['./signer-item-form.component.scss'],
})
export class SignerItemFormComponent extends Destroyable implements OnInit {
  @Input() form: FormGroup
  @Input() role: string
  @Input() setFormDataFunc: (form: FormGroup, signer: SignerOptionItem) => void
  @Input() removable = true
  @Input() ampKey: string
  @Input() isUserEnabled = false
  @Input() isGuestEnabled = true

  @Output() remove = new EventEmitter()

  get saveCtrl() {
    return this.form?.get('save') as FormControl
  }

  get idPhotoCtrl() {
    return this.form?.get('id_photo_required') as FormControl
  }

  get selfiePhotoCtrl() {
    return this.form?.get('selfie_photo_required') as FormControl
  }

  sub: Subscription
  @ViewChild('signerInput') set signerInput(t: SignerCustomInputComponent) {
    if (this.sub) {
      this.sub.unsubscribe()
    }

    this.sub = t.selectItem.pipe(untilDestroy(this)).subscribe((data) => {
      this.onSignerSelect(data)
    })
  }

  constructor() {
    super()
  }

  ngOnInit(): void {}

  get shouldSaveContact() {
    return !!this.saveCtrl.value
  }

  get isIdPhotoRequired() {
    return !!this.idPhotoCtrl.value
  }

  get isSelfiePhotoRequired() {
    return !!this.selfiePhotoCtrl.value
  }

  toggleSaveContact() {
    this.saveCtrl.setValue(!this.saveCtrl.value)
  }

  toggleIdPhoto() {
    this.idPhotoCtrl.setValue(!this.idPhotoCtrl.value)
    if (this.idPhotoCtrl.value) {
    }
  }

  toggleSelfiePhoto() {
    this.selfiePhotoCtrl.setValue(!this.selfiePhotoCtrl.value)
    if (this.selfiePhotoCtrl.value) {
    }
  }

  getPhotosRequirementDescription() {
    if (!this.isIdPhotoRequired && !this.isSelfiePhotoRequired) {
      return $localize`both national ID & Selfie Not Required`
    } else if (this.isIdPhotoRequired && !this.isSelfiePhotoRequired) {
      return $localize`Only National ID is Required`
    } else if (!this.isIdPhotoRequired && this.isSelfiePhotoRequired) {
      return $localize`Only Selfie is Required`
    } else {
      return $localize`Both National ID & Selfie are Required`
    }
  }

  onSignerSelect(item: SignerOptionItem) {
    this.setFormDataFunc?.(this.form, item)
  }

  onRemove() {
    this.remove.emit()
  }
}
